import { Icon, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PHONE_SQUARE_TOUCH_TARGET_SX } from "~/components/mobile/bottomNav/mobileBottomNav";
import useScanSoundPreference from "~/components/mobile/scanFeedback/useScanSoundPreference";

export interface ScanSoundToggleProps {
	size?: "large" | "medium" | "small";
}

const ScanSoundToggle = ({ size = "medium" }: ScanSoundToggleProps) => {
	const { soundMuted, toggleSoundMuted } = useScanSoundPreference();
	const { t } = useTranslation("mobile");

	return (
		<IconButton
			aria-label={soundMuted ? t("scanFeedback.unmuteSound") : t("scanFeedback.muteSound")}
			aria-pressed={soundMuted}
			onClick={toggleSoundMuted}
			size={size}
			sx={PHONE_SQUARE_TOUCH_TARGET_SX}
		>
			<Icon>{soundMuted ? "volume_off" : "volume_up"}</Icon>
		</IconButton>
	);
};

export default ScanSoundToggle;
